import { render, staticRenderFns } from "./MenuItemEsmax.vue?vue&type=template&id=3bd87bf8&scoped=true&"
import script from "./MenuItemEsmax.vue?vue&type=script&lang=js&"
export * from "./MenuItemEsmax.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemEsmax.vue?vue&type=style&index=0&id=3bd87bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd87bf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3bd87bf8', component.options)
    } else {
      api.reload('3bd87bf8', component.options)
    }
    module.hot.accept("./MenuItemEsmax.vue?vue&type=template&id=3bd87bf8&scoped=true&", function () {
      api.rerender('3bd87bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuItemEsmax.vue"
export default component.exports